import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Button from "src/components/Button";
import { useTermsOfServiceUrl } from "src/components/form/AgreeTermsCheckbox";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import AuthLayout from "src/components/layout/auth-layout/AuthLayout";
import useFetchProfile from "src/hooks/api/useFetchProfile";
import usePost from "src/hooks/rest/usePost";
import useAuth from "src/hooks/selectors/useAuth";

const TermsOfServiceView = ({ t }: Translation) => {
	const auth = useAuth();
	const navigate = useNavigate();
	const termsOfServiceUrl = useTermsOfServiceUrl();
	const [agreeToTerms] = usePost("/auth/terms-of-services/agree");
	const [isLoading, setIsLoading] = useState(false);
	const { fetchProfile } = useFetchProfile();

	const handleAgreeToTerms = async () => {
		setIsLoading(true);
		agreeToTerms({})
			.then(async () => {
				await fetchProfile();
				navigate("/dashboard");
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	if (auth.terms_of_service?.agreed && !auth?.terms_of_service?.has_new) {
		return <Navigate to="/dashboard" />;
	}

	return (
		<AuthLayout
			head={{ title: t("title"), description: t("description") }}
			contentClassName="gap-0"
		>
			<a
				className="text-primary underline"
				href={termsOfServiceUrl}
				target="_blank"
				rel="noopener noreferrer"
			>
				{t("link")}
			</a>
			<Button
				type="primary"
				className="w-full mt-6"
				onClick={handleAgreeToTerms}
				loading={isLoading}
			>
				{t("agree")}
			</Button>
		</AuthLayout>
	);
};

TermsOfServiceView.locale = {
	nl: {
		title: "Algemene voorwaarden",
		description:
			"De algemene voorwaarden voor het gebruik van {{tenant.name}} zijn geupdate.",
		link: "Bekijk de algemene voorwaarden",
		agree: "Ik ga akkoord",
	},
	en: {
		title: "Terms of Service",
		description:
			"The terms of service for {{tenant.name}} have been updated.",
		link: "View the terms of service",
		agree: "I agree",
	},
};

export default withTranslation(TermsOfServiceView);
